module.exports = "pegasus/assets/background-patterns/fall-pets-theme.jpg";